import { render } from "./day.calendar.vue?vue&type=template&id=65adbaa2"
import script from "./day.calendar.vue?vue&type=script&lang=js"
export * from "./day.calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__